import axios from 'axios';

import { URLS } from './constants';

export const fetch = axios.create({
  baseURL: URLS.API_URL,
  withCredentials: true,
});
